import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    AccordionContentDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    content: {
        flexDirection: "column"
    }
});

export const useStyles = ({
    currentMeasures,
    isInset,
    spaces
}: AccordionContentDynamicStyleType) => {
    const styles = {
        content: {
            paddingBottom: currentMeasures.contentPaddingBottom,
            paddingStart: currentMeasures.paddingHorizontal,
            paddingEnd: currentMeasures.paddingHorizontal,
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    if(isInset) {
        styles.content.paddingStart = currentMeasures.paddingHorizontal + currentMeasures.iconSize + currentMeasures.gap;
    }

    return styles;
};
export default stylesheet;
